'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _set = require('lodash/set');
var _get = require('lodash/get');
var _merge = require('lodash/merge');
Entry.Davinci = new (/*#__PURE__*/function () {
  function Davinci() {
    (0, _classCallCheck2["default"])(this, Davinci);
    this.id = '2D.1';
    this.url = 'http://www.dasanbooks.com';
    this.imageName = 'davinciai.png';
    this.title = {
      "en": "Davinci",
      "ko": "다빈치"
    };
    this.name = 'davinci';
    this.blockIds = {};
    this.isExecBlock = false;
    this.cacheValues = [];
    this.cacheIndex = 0;
    this.radioTime = 0;
  }
  return (0, _createClass2["default"])(Davinci, [{
    key: "getHashKey",
    value: function getHashKey() {
      var key = new Date().getSeconds().toString(16);
      if (key.length === 1) {
        key += (Math.random() * 16 | 0).toString(16);
      }
      return Entry.generateHash() + key;
    }
  }, {
    key: "setZero",
    value: function setZero() {
      Entry.hw.sendQueue = (0, _defineProperty2["default"])({}, this.getHashKey(), {
        type: 'RST'
      });
      Entry.hw.update();
      this.blockIds = {};
      this.isExecBlock = false;
      this.execTimeFlag = false;
      this.radioTime = 0;
    }
  }, {
    key: "sendMessage",
    value: function sendMessage(_ref) {
      var socket = _ref.socket,
        _ref$sendQueue = _ref.sendQueue,
        sendQueue = _ref$sendQueue === void 0 ? {} : _ref$sendQueue;
      if (!_.isEmpty(sendQueue)) {
        var keys = Object.keys(sendQueue);
        var uniqueKey = this.getHashKey();
        socket.emit('message', {
          data: JSON.stringify(sendQueue),
          mode: socket.mode,
          type: 'utf8',
          key: uniqueKey
        }, function (data) {
          if (data === uniqueKey) {
            keys.forEach(function (key) {
              delete sendQueue[key];
            });
          }
        });
      }
    }
  }, {
    key: "asyncFlowControl",
    value: function asyncFlowControl(_ref2, scope) {
      var script = _ref2.script,
        data = _ref2.data;
      if (!this.isExecBlock && !scope.isStart) {
        var blockId = this.getHashKey();
        this.isExecBlock = true;
        scope.isStart = true;
        scope.timeFlag = 1;
        this.nowBlockId = blockId;
        this.blockIds[blockId] = false;
        _merge(Entry.hw.sendQueue, (0, _defineProperty2["default"])({}, blockId, data));
        Entry.hw.update();
        setTimeout(function () {
          scope.timeFlag = 0;
        });
        return false;
      } else if (this.blockIds[this.nowBlockId] && scope.timeFlag === 0) {
        delete this.blockIds[this.nowBlockId];
        delete scope.isStart;
        this.execTimeFlag = 0;
        this.execTimeFlag = undefined;
        this.isExecBlock = false;
        Entry.engine.isContinue = false;
        return true;
      }
      return false;
    }
  }, {
    key: "postCallReturn",
    value: function postCallReturn(args) {
      var script = args.script;
      if (!this.asyncFlowControl(args, script)) {
        return Entry.STATIC.BREAK;
      }
    }
  }, {
    key: "checkValue",
    value: function checkValue(args) {
      var script = args.script,
        key = args.key;
      var entity = script.entity,
        executor = script.executor;
      var scope = executor.scope;
      var _scope$cacheValue = scope.cacheValue,
        cacheValue = _scope$cacheValue === void 0 ? {} : _scope$cacheValue;
      var value = _get(cacheValue, key);
      if (value) {
        return value;
      } else if (!this.asyncFlowControl(args, scope)) {
        throw new Entry.Utils.AsyncError();
      }
    }
  }, {
    key: "afterSend",
    value: function afterSend(data) {
      // Object.assign(data, {
      //     OUTPUT: {},
      // });
    }
  }, {
    key: "afterReceive",
    value: function afterReceive(_ref3) {
      var _ref3$blockId = _ref3.blockId,
        blockId = _ref3$blockId === void 0 ? '' : _ref3$blockId,
        RADIO = _ref3.RADIO;
      if (blockId in this.blockIds) {
        this.blockIds[blockId] = true;
      } else if (RADIO && Entry.engine.isState('run') && RADIO.time > this.radioTime) {
        this.radioTime = RADIO.time;
        Entry.engine.fireEvent('DavinciRadioReceive');
      }
    }
  }]);
}())();
Entry.Davinci.blockMenuBlocks = ['davinci_led_toggle', 'davinci_get_led', 'davinci_show_string', 'davinci_show_image', 'davinci_set_analog', 'davinci_set_digital', 'davinci_get_analog', 'davinci_get_analog_map', 'davinci_get_digital', 'davinci_get_button', 'davinci_get_sensor', 'davinci_get_accelerometer', 'davinci_get_gyro', 'davinci_get_magnet', 'davinci_play_note', 'davinci_play_melody', 'davinci_change_bpm', 'davinci_set_bpm'];
Entry.Davinci.getBlocks = function () {
  return {
    davinci_led_toggle: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      skeleton: 'basic',
      statements: [],
      template: 'LED의 X:%1 Y:%2 %3 %4',
      params: [{
        type: 'Dropdown',
        options: [['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Dropdown',
        options: [['A', '0'], ['B', '1'], ['C', '2'], ['D', '3'], ['E', '4'], ['F', '5']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Dropdown',
        options: [['켜기', '0'], ['끄기', '1'], ['반전', '2']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciLed',
      isNotFor: ['davinci'],
      def: {
        params: [],
        type: 'davinci_led_toggle'
      },
      paramsKeyMap: {
        X: 0,
        Y: 1,
        VALUE: 2
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var x = script.getField('X');
        var y = script.getField('Y');
        var data = {
          type: 'SET_LED',
          data: {
            x: x,
            y: y,
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_get_led: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_boolean_field',
      statements: [],
      template: 'LED의 X:%1 Y:%2 상태값',
      params: [{
        type: 'Dropdown',
        options: [['1', '0'], ['2', '1'], ['3', '2'], ['4', '3'], ['5', '4']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Dropdown',
        options: [['A', '0'], ['B', '1'], ['C', '2'], ['D', '3'], ['E', '4'], ['F', '5']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciLed',
      isNotFor: ['davinci'],
      def: {
        params: [],
        type: 'davinci_get_led'
      },
      paramsKeyMap: {
        X: 0,
        Y: 1
      },
      func: function func(sprite, script) {
        var x = script.getNumberValue('X');
        var y = script.getNumberValue('Y');
        var data = {
          type: 'GET_LED',
          data: {
            x: x,
            y: y
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "LED.".concat(x, ".").concat(y)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['LED']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "LED.".concat(x, ".").concat(y), returnData);
        }
        return returnData;
      }
    },
    davinci_show_string: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      skeleton: 'basic',
      statements: [],
      template: '%1 출력하기 %2',
      params: [{
        type: 'Block',
        accept: 'string'
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciLed',
      isNotFor: ['davinci'],
      def: {
        params: [{
          type: 'text',
          params: ['Hello!']
        }],
        type: 'davinci_show_string'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getStringValue('VALUE');
        value = value.replace(/[^A-Za-z0-9_\`\~\!\@\#\$\%\^\&\*\(\)\-\=\+\\\{\}\[\]\'\"\;\:\<\,\>\.\?\/\s]/gim, '');
        var data = {
          type: 'SET_STRING',
          data: {
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_show_image: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      skeleton: 'basic',
      statements: [],
      template: '%1 이모티콘 출력하기 %2',
      params: [{
        type: 'Dropdown',
        options: [['하트', 0], ['작은하트', 1], ['정답', 2], ['오답', 3], ['웃는얼굴', 5], ['화난얼굴', 6], ['슬픈얼굴', 7], ['소얼굴', 8], ['무표정한얼굴', 9], ['사슴', 12], ['물음표', 13], ['느낌표', 14], ['기린', 15], ['개', 16], ['위', 20], ['왼쪽', 21], ['아래', 22], ['오른쪽', 23]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciLed',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_show_image'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'SET_IMAGE',
          data: {
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_set_analog: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      skeleton: 'basic',
      statements: [],
      template: '아날로그 핀 %1번을 %2으로 설정 %3',
      params: [{
        type: 'Dropdown',
        options: [['1번', 0], ['2번', 1], ['3번', 2], ['4번', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Block',
        accept: 'string',
        defaultType: 'number',
        value: 0
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciDirect',
      isNotFor: ['davinci'],
      def: {
        params: [null, {
          type: 'number',
          params: [0]
        }],
        type: 'davinci_set_analog'
      },
      paramsKeyMap: {
        PIN: 0,
        VALUE: 1
      },
      func: function func(_sprite, script) {
        var pin = script.getField('PIN');
        var value = script.getNumberValue('VALUE', script);
        value = Math.min(value, 255);
        value = Math.max(value, 0);
        var data = {
          type: 'SET_ANALOG',
          data: {
            pin: pin,
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_set_digital: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      skeleton: 'basic',
      statements: [],
      template: '디지털 핀 %1번을 %2 %3',
      params: [{
        type: 'Dropdown',
        options: [['1번', 0], ['2번', 1], ['3번', 2], ['4번', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Dropdown',
        options: [['켜기', '0'], ['끄기', '1'], ['반전', '2']],
        value: '0',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciDirect',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_set_digital'
      },
      paramsKeyMap: {
        PIN: 0,
        VALUE: 1
      },
      func: function func(_sprite, script) {
        var value = script.getField('VALUE');
        var pin = script.getField('PIN');
        var data = {
          type: 'SET_DIGITAL',
          data: {
            pin: pin,
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_get_analog: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_string_field',
      statements: [],
      template: '아날로그 핀 %1번 입력 값',
      params: [{
        type: 'Dropdown',
        options: [['1번', 0], ['2번', 1], ['3번', 2], ['4번', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciDirect',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_analog'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_ANALOG',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_ANALOG.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_ANALOG']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_ANALOG.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_digital: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_boolean_field',
      statements: [],
      template: '디지털 핀 %1번 입력 값',
      params: [{
        type: 'Dropdown',
        options: [['1번', 0], ['2번', 1], ['3번', 2], ['4번', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciDirect',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_digital'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_DIGITAL',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_DIGITAL.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_DIGITAL']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_DIGITAL.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_button: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_boolean_field',
      statements: [],
      template: '%1버튼을 눌렀는가?',
      params: [{
        type: 'Dropdown',
        options: [['A', 10], ['B', 11], ['A + B', 12]],
        value: 10,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciSensor',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_button'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_BUTTON',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_BUTTON.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_BUTTON']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          console.log("RETURN: " + returnData);
          _set(scope.cacheValue, "GET_BUTTON.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_sensor: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_string_field',
      statements: [],
      template: '%1 센서값',
      params: [{
        type: 'Dropdown',
        options: [['빛', 'lightLevel'], ['온도', 'temperature'], ['소리', 'soundLevel'], ['자기', 'compassHeading']],
        value: 'temperature',
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciSensor',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_sensor'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_SENSOR',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_SENSOR.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_SENSOR']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_SENSOR.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_accelerometer: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_string_field',
      statements: [],
      template: '가속도 센서 %1의 값',
      params: [{
        type: 'Dropdown',
        options: [['x축', 0], ['y축', 1], ['z축', 2]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciSensor',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_accelerometer'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_ACCELEROMETER',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_ACCELEROMETER.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_ACCELEROMETER']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_ACCELEROMETER.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_gyro: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_string_field',
      statements: [],
      template: '자이로 센서 %1의 값',
      params: [{
        type: 'Dropdown',
        options: [['x축', 0], ['y축', 1], ['z축', 2]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciSensor',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_gyro'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_GYRO',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_GYRO.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_GYRO']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_GYRO.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_get_magnet: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic_string_field',
      statements: [],
      template: '지자기 센서 %1의 값',
      params: [{
        type: 'Dropdown',
        options: [['x축', 0], ['y축', 1], ['z축', 2]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }],
      events: {},
      "class": 'DavinciSensor',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_get_magnet'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getField('VALUE');
        var data = {
          type: 'GET_MAGNET',
          data: {
            value: value
          }
        };
        var returnData = Entry.Davinci.checkValue({
          script: script,
          data: data,
          key: "GET_MAGNET.".concat(value)
        });
        if (!returnData) {
          returnData = _get(Entry.hw.portData, ['GET_MAGNET']);
          var executor = script.executor;
          var scope = executor.scope;
          if (!scope.cacheValue) {
            scope.cacheValue = {};
          }
          _set(scope.cacheValue, "GET_MAGNET.".concat(value), returnData);
        }
        return returnData;
      }
    },
    davinci_play_note: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic',
      statements: [],
      template: '%1음을 %2박자 연주하기 %3',
      params: [{
        type: 'Dropdown',
        options: [['낮은 도', 1], ['낮은 도#', 22], ['낮은 레', 2], ['낮은 레#', 23], ['낮은 미', 3], ['낮은 파', 4], ['낮은 파#', 24], ['낮은 솔', 5], ['낮은 솔#', 25], ['낮은 라', 6], ['낮은 라#', 26], ['낮은 시', 7], ['가온 도', 8], ['가온 도#', 27], ['가온 레', 9], ['가온 레#', 28], ['가온 미', 10], ['가온 파', 11], ['가온 파#', 29], ['가온 솔', 12], ['가온 솔#', 30], ['가온 라', 13], ['가온 라#', 31], ['가온 시', 14], ['높은 도', 15], ['높은 도#', 32], ['높은 레', 16], ['높은 레#', 33], ['높은 미', 17], ['높은 파', 18], ['높은 파#', 34], ['높은 솔', 19], ['높은 솔#', 35], ['높은 라', 20], ['높은 라#', 36], ['높은 시', 21]],
        value: 8,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Dropdown',
        options: [['1', 0], ['1/2', 4], ['1/4', 5], ['1/8', 6], ['1/16', 7], ['2', 1], ['4', 2], ['8', 3]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciMusic',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_play_note'
      },
      paramsKeyMap: {
        NOTE: 0,
        BEAT: 1
      },
      func: function func(sprite, script) {
        var note = script.getField('NOTE');
        var beat = script.getField('BEAT');
        var data = {
          type: 'PLAY_NOTE',
          data: {
            note: note,
            beat: beat
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_play_melody: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic',
      statements: [],
      template: '%1 노래 연주하기%2',
      params: [{
        type: 'Dropdown',
        options: [['띠링', 0], ['와우와우와우', 1], ['올라가기', 2], ['내려가기', 3], ['파워업', 4], ['파워다운', 5], ['마법봉', 6], ['비상벨', 7]],
        value: 0,
        fontSize: 11,
        bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
        arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciMusic',
      isNotFor: ['davinci'],
      def: {
        type: 'davinci_play_melody'
      },
      paramsKeyMap: {
        MELODY: 0
      },
      func: function func(sprite, script) {
        var melody = script.getField('MELODY');
        var data = {
          type: 'PLAY_MELODY',
          data: {
            melody: melody
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_change_bpm: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic',
      statements: [],
      template: '연주 속도를 %1BPM 만큼 바꾸기 %2',
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciMusic',
      isNotFor: ['davinci'],
      def: {
        params: [{
          type: 'number',
          params: [20]
        }],
        type: 'davinci_change_bpm'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getNumberValue('VALUE');
        var data = {
          type: 'CHANGE_BPM',
          data: {
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    },
    davinci_set_bpm: {
      color: EntryStatic.colorSet.block["default"].HARDWARE,
      outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
      fontColor: '#ffffff',
      skeleton: 'basic',
      statements: [],
      template: '연주 속도를 %1BPM으로 정하기 %2',
      params: [{
        type: 'Block',
        accept: 'string',
        defaultType: 'number'
      }, {
        type: 'Indicator',
        img: 'block_icon/hardware_icon.svg',
        size: 12
      }],
      events: {},
      "class": 'DavinciMusic',
      isNotFor: ['davinci'],
      def: {
        params: [{
          type: 'number',
          params: [120]
        }],
        type: 'davinci_set_bpm'
      },
      paramsKeyMap: {
        VALUE: 0
      },
      func: function func(sprite, script) {
        var value = script.getNumberValue('VALUE');
        var data = {
          type: 'SET_BPM',
          data: {
            value: value
          }
        };
        return Entry.Davinci.postCallReturn({
          script: script,
          data: data
        });
      }
    }
  };
};
module.exports = Entry.Davinci;